import createStyles from '@mui/styles/createStyles';

export default function styles() {
  return createStyles({
    root: {},
  });
}
